
<template >
    <div class="top-pad">
    <div class="top-bar">
        <div class="top-title">
            
        </div>

        <div class="logo">
        <img class="image" src="./assets/logo.jpg" alt=" ad-image" />
        </div>

        <div class="search-container">




                
        </div>
        <ApiGraphExVue /> 
        <div>
            <MenuButton @toggle-menu="toggleMenu"></MenuButton>
            <MenuMain :is-open="menuOpen"></MenuMain>
        </div>

        <div class="wallet-button">
           
        </div>

        
        <div class="wallet-button2">
            <LoginAuth/>
        </div>
        

    </div>
    </div>
    
</template>
  
<script>
//import SpaceXLaunches from './SpaceXLaunches.vue';
import LoginAuth from './LoginAuth.vue';
//import LogoutAuth from './LogoutAuth.vue';
import MenuButton from './MenuButton.vue';
import MenuMain from './MenuMain.vue';


//import AdEx from './AdEx.vue';


import ApiGraphExVue from './ApiGraphEx.vue';

//import HistoryPage from './HisotryPage.vue';


export default {
    name: 'YourComponent',
    components: {
        LoginAuth,

       // AdEx,
        //LogoutAuth,
        
        MenuButton,
        MenuMain,
        //SpaceXLaunches,
        ApiGraphExVue,
       // HistoryPage,


    },

    data() {
        return {
            menuOpen: false,
            showResults: false,
        }
    },

    methods: {

        toggleMenu() {
      this.menuOpen = !this.menuOpen
    },}}


   

      


</script>

<style >
.top-pad{
    padding-bottom: 5%;
}
.top-bar {
    height: 70px;
    width: 100%;
    background-color: rgb(238, 238, 238);

    position: fixed;

    top: 0;
    left: 0;
    z-index: 10000000;
    

}
.image{
    position: absolute;
    top: 50%;
    left: 120px;
    transform: translateY(-50%);
    width: 120px;
    border-radius: 6px;
    

}
.top-title {
    position: absolute;
    /* this positions the title absolutely within the container */
    bottom: 25%;
    /* this moves the title to the top of the container */
    left: 10%;
    /* this aligns the title to the left of the container */
    width: 10%;
    /* this makes the title span the full width of the container */
    text-align: left;
    /* this centers the title text within the title container */
    color: rgb(0, 0, 0);
    font-size: 2em;
    padding-left: 10pt;
}

.wallet-button {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);

}
.wallet-button2 {
    position: absolute;
    top: 50%;
    right: 100px;
    transform: translateY(-50%);

}

label {

    color: black;

}

/* Change the background color */
body {
    background-color: #00000088;
}

/* Change the font for the entire website */
body {
    color: grey;
}

/* Change the color of the text */
p {
    color: rgb(255, 255, 255);
}

/* Change the size of the text */
h1,
h2,
h3 {
    font-size: 1.5em;
}

.menuResults{
    display: flex;
  justify-content: center;
  
  height: 100vh; /* Adjust this to set the desired height */

}

.search-container {
    width: 100%;
    left: 0%;
    bottom: 25%;
    position: absolute;
    
    

}
.search-container input:hover {
        background-color: #c2baba;

    }


.search-container input {
    width: 40%;
    /* adjust width as desired */
    height: 40px;
    /* adjust height as desired */
    padding: 0 20px;
    /* add padding as desired */
    border: none;
    /* remove border if desired */
    border-radius: 5px;
    /* add border radius to make it rounded */
    font-size: 20px;
    /* adjust font size as desired */
    font-family: 'Courier New', Courier, monospace;
    
    
}
.result-background {
  position: fixed;
  top: 70px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
 background-color: rgba(0, 0, 0, 0.4); 
  z-index: 4;
}

.result-item {
    margin-bottom: 10px;
    visibility: visible;
    color: #000;
    cursor: pointer;

}

.categories-container {

    display: flex;
    justify-content: center;
}

.category-container {
    width: 300px;
    height: 350px;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0px;
    border-radius: 0px;
    margin-right: 0px;
    top: 80px;
    z-index: 5;
}

.category-title {
    position: absolute;
    /* this positions the title absolutely within the container */
    top: -10%;
    /* this moves the title to the top of the container */
    left: 0;
    /* this aligns the title to the left of the container */
    width: 100%;
    /* this makes the title span the full width of the container */
    text-align: center;
    /* this centers the title text within the title container */
    color: rgb(0, 0, 0);
    border-bottom: 2px solid black;
    padding-bottom: 5px;

}


.category-container.category1 {
    background-color: rgb(238, 238, 238);
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
    /* adjust color as you see fit */
}

.category-container.category2 {
    background-color: rgb(238, 238, 238);
    /* adjust color as you see fit */
}

.category-container.category3 {
    background-color: rgb(238, 238, 238);
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    /* adjust color as you see fit */
}

.popup-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px); */

    justify-content: center;
    align-items: center;
    z-index: 1;

}

.popup {


    border-radius: 20px;
    z-index: 2;
    position: relative;
}

.close-popup {
    position: absolute;
    top: 0%;
    left: 91%;
    padding: 10px;
    cursor: pointer;
    font-size: 20px;

    background-color: darkgray;
    border-radius: 8px;
    z-index: 10000000;

}

.ad-container {
    z-index: 3;
}
</style>